import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Components/header.jsx';
import MainPage from './pages/MainPage.jsx';
import AboutPage from './pages/about.jsx';
import Footer from './Components/footer.jsx';
import ServicePage from './pages/services.jsx';
import ConsultationForm from './pages/ConsultationForm.jsx';
import CookieConsent from './Components/CookiesConsent.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';
import OrthoticsPage from './pages/Orthotics.jsx';
import LunularLaserPage from './pages/LunularLaser.jsx';
import Blog from './pages/Blog.jsx';
import BlogPost from './pages/BlogPost.jsx';
import ContactAdmin from './pages/ContactAdmin.jsx';
import BlogAdmin from './pages/BlogAdmin.jsx';
import AdminLogin from './pages/AdminLogin.jsx';
import ProtectedRoute from './Components/ProtectedRoute.jsx';
import CustomPage from './pages/CustomPage.jsx';
import FormTest from './pages/FormTest.jsx';

import ScrollToTop from './Components/ScrollToTop.jsx';

function App() {
  return (
    <Router basename="/">
      <ScrollToTop /> {/* Added ScrollToTop component */}
      <div className="flex flex-col min-h-screen relative">
        <Header />
        <div className="flex-grow mt-16">
          <Routes>
            <Route exact path="/" element={<MainPage />} />
            <Route exact path="/about" element={<AboutPage />} />
            <Route exact path="/services" element={<ServicePage />} />
            <Route exact path="/consultation-form" element={<ConsultationForm/>}/>
            <Route exact path="/ConsultationForm" element={<ConsultationForm/>}/>
            <Route exact path="/Orthotics" element={<OrthoticsPage />} />
            <Route exact path="/orthotics" element={<OrthoticsPage />} />
            <Route exact path="/lunular-laser" element={<LunularLaserPage />} />
            <Route exact path="/blog" element={<Blog />} />
            <Route exact path="/blog/:slug" element={<BlogPost />} />
            <Route exact path="/admin/contacts" element={<ContactAdmin />} />
            <Route exact path="/admin-login" element={<AdminLogin onLoginSuccess={() => window.location.href = '/blog-admin'} />} />
            <Route exact path="/blog-admin" element={
              <ProtectedRoute>
                <BlogAdmin />
              </ProtectedRoute>
            } />
                    <Route exact path="/legal" element={<CustomPage />} />
                    <Route exact path="/form-test" element={<FormTest />} />
                    <Route exact path="/:slug" element={<CustomPage />} />
                    <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        <CookieConsent />
        <Footer/>
      </div>
    </Router>
  );
}
export default App;